import React, { createContext, useState } from 'react'

import { id } from 'hooks'

export interface IRawTab {
  name: string
  tabID: string
  isDefault: boolean
  position: number
}

export interface IUseTabs {
  rawTabs: IRawTab[]
  setRawTabs: React.Dispatch<React.SetStateAction<IRawTab[]>>
  selectedTab: IRawTab
  setSelectedTab: React.Dispatch<React.SetStateAction<IRawTab>>
  lastSelectedDefaultTab: IRawTab
  setLastSelectedDefaultTab: React.Dispatch<React.SetStateAction<IRawTab>>
}

export const TabsContext = createContext<IUseTabs | null>(null);

export const TabsProvider: React.FC = ({ children }) => {
  const DEFAULT_FIRST_TAB: IRawTab = {
    name: '',
    tabID: id(),
    isDefault: true,
    position: 0,
  }

  const [rawTabs, setRawTabs] = useState<IRawTab[]>([])
  const [selectedTab, setSelectedTab] = useState<IRawTab>(DEFAULT_FIRST_TAB)
  const [lastSelectedDefaultTab, setLastSelectedDefaultTab] = useState<IRawTab>(DEFAULT_FIRST_TAB)

  return (
    <TabsContext.Provider value={{
      rawTabs,
      setRawTabs,
      selectedTab,
      setSelectedTab,
      lastSelectedDefaultTab,
      setLastSelectedDefaultTab,
    }}>
      {children}
    </TabsContext.Provider>
  )
}
